import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Table from "../../../components/elements/table/Table";
import { order_status_filter } from "../../../constant/Constant";
import Select from "../../../components/form/Select";
import Input from "../../../components/form/Input";
import Button from "../../../components/form/Button";
import { setTitle } from "../../../helpers/MetaTag";
import DeleteModal from "../../../components/common/DeleteModal";
import { getOrderList } from "../../../services/orderService";
import Modal from "../../../components/elements/Modal/Modal";
import OrderStatusChange from "../order/OrderStatusChange";
import { useDebounce } from "../../../hooks/useDebounce";
import { getUserList } from "../../../services/userService";
import SelectDropdownSearch from "../../../components/form/SelectDropdownSearch";
import dayjs from "dayjs";
import DatePickerInput from "../../../components/form/DatePickerInput";
import Papa from "papaparse";
import { country } from "../../../helpers";

const OrderList = () => {
  const location = useLocation();
  // setTitle("HJL");
  const navigate = useNavigate();
  const [limit, setLimit] = useState(10);
  const [status, setStatus] = useState("all");
  const [featured, setFeatured] = useState(" ");
  const [offset, setOffset] = useState(0);
  const [sort, setSort] = useState({ orderBy: "", ordering: "DESC" });
  const [currentPage, setCurrentPage] = useState(1);
  const [userDetails, setUserDetails] = useState({});
  const [pagination, setPagination] = useState({
    hasNextPage: false,
    hasPrevPage: false,
  });
  const [statusFilterData, setStatusFilterData] = useState(order_status_filter || []);
  const [userFilterData, setUserFilterData] = useState([]);
  const [keyword, setKeyword] = useState("");
  const search = useDebounce(keyword, 200);
  const [list, setList] = useState({
    loading: true,
    data: [],
    pageCount: 0,
    totalItem: 0,
  });
  const [count, setCount] = useState(0);
  const [selectedItems, setSelectedItems] = useState([]);
  const [deleteModal, setDeleteModal] = useState({
    isOpen: false,
    id: null,
  });
  const [deleteComplete, setDeleteComplete] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [statusDetails, setStatusDetails] = useState({});
  const [userSearchKey, setUserSearchKey] = useState("");
  const [filterSearchKey, setFilterSearchKey] = useState("");
  const [filters, setFilters] = useState({
    status: null,
    userId: null,
  });
  const [orderStatus, setOrderStatus] = useState();
  const [statusKeyword, setStatusKeyword] = useState("");
  const [paymentStatus, setPaymentStatus] = useState();
  const [paymentStatusKeyword, setPaymentStatusKeyword] = useState("");
  const [payment, setPayment] = useState();
  const [paymentKeyword, setPaymentKeyword] = useState("");
  const [category, setCategory] = useState();
  const [categoryKeyword, setCategoryKeyword] = useState("");
  const [maxDate, setMaxDate] = useState({ startDate: null, endDate: null });
  const [totalPriceSum, setTotalPriceSum] = useState(0);
  const [totalGSTSum, setTotalGSTSum] = useState(0);
  const [userList, setUserList] = useState({ data: [] });
  const [user, setUser] = useState();
  const [userKeyword, setUserKeyword] = useState("");

  useEffect(() => {
    if (filterSearchKey) {
      setStatusFilterData(
        order_status_filter?.filter((item) =>
          item?.name?.toLocaleLowerCase().includes(filterSearchKey?.toLocaleLowerCase())
        )
      );
    } else {
      setStatusFilterData(order_status_filter);
    }
  }, [filterSearchKey]);

  useEffect(() => {
    if (userSearchKey) {
      setUserFilterData(
        userList?.filter((item) => item?.name?.toLocaleLowerCase().includes(userSearchKey?.toLocaleLowerCase()))
      );
    } else {
      setUserFilterData(userList);
    }
  }, [userSearchKey]);

  const handleFilterChange = useCallback((name, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  }, []);

  useEffect(() => {
    const sum = list?.data?.reduce((acc, item) => {
      const price = item?.total_price ? parseFloat(item?.total_price) : 0;
      return acc + price;
    }, 0);

    const gst_sum = list?.data?.reduce((acc, item) => {
      const price = item?.vat_charge ? parseFloat(item?.vat_charge) : 0;
      return acc + price;
    }, 0);

    setTotalPriceSum(sum);
    setTotalGSTSum(gst_sum);
  }, [list]);

  const data = [
    { name: "All Items", value: "All" },
    { name: "5 Items", value: 5 },
    { name: "10 Items", value: 10 },
    { name: "20 Items", value: 20 },
    { name: "30 Items", value: 30 },
    { name: "50 Items", value: 50 },
    { name: "100 Items", value: 100 },
  ];

  const statusData = [
    { name: "Processing", _id: 1 },
    { name: "Accepted", _id: 2 },
    { name: "Out For Delivery", _id: 3 },
    { name: "Shipped", _id: 4 },
    { name: "Cancel", _id: 5 },
  ];

  const paymentStatusData = [
    { name: "Paid", _id: 1 },
    { name: "Pending", _id: 2 },
  ];

  const paymentData = [
    { name: "Helcim", _id: "Helcim" },
    { name: "Moneris", _id: "Moneris" },
  ];

  const categoryData = [
    { name: "Labels", _id: 1 },
    { name: "RJS Labels", _id: 2 },
    { name: "Cards", _id: 3 },
    { name: "Masks", _id: 4 },
  ];

  //Page data limit function
  const handleChange = (value) => {
    if (value?.value !== "All") {
      setOffset(0);
      setLimit(value?.value);
      setSelectedItems([]);
    } else {
      setOffset(0);
      setLimit(count);
      setCurrentPage(1);
      setSelectedItems([]);
    }
  };

  useEffect(() => {
    getUserList({ perPage: 999, role: "user", keyword: userKeyword }).then((res) => {
      if (res && res?.docs?.status === 200) {
        setUserList({
          data: res.docs?.data,
        });
      }
    });
  }, [userKeyword]);

  //   loading the member list >>>>>>>>>
  const loadList = useCallback(() => {
    const order_status_filter = {};
    if (filters.status && Array.isArray(filters.status) && filters.status.length > 0) {
      filters.status.forEach((item, i) => (order_status_filter[`status[${i}]`] = item));
    }
    const user_status_filter = {};
    if (filters.userId && Array.isArray(filters.userId) && filters.userId.length > 0) {
      filters.userId.forEach((item, i) => (user_status_filter[`userId[${i}]`] = item));
    }
    setList((pre) => ({
      ...pre,
      data: [],
      loading: true,
    }));
    let payload = {
      ...sort,
      keyword: search,
      perPage: limit,
      page: currentPage,
      ...order_status_filter,
      ...user_status_filter,
    };

    getOrderList(
      orderStatus?._id
        ? { ...payload, status: orderStatus?._id }
        : user?._id
        ? { ...payload, user_id: user?._id }
        : paymentStatus?._id
        ? { ...payload, payment_status: paymentStatus?._id }
        : payment?._id
        ? { ...payload, payment: payment?._id }
        : category?._id
        ? { ...payload, parent_category_id: category?._id }
        : maxDate?.startDate
        ? {
            ...payload,
            dateSearchMin: new Date(maxDate?.startDate).toISOString(),
            dateSearchMax: new Date(new Date(maxDate?.endDate).setUTCHours(23, 59, 59, 999)).toISOString(),
          }
        : payload
    ).then((res) => {
      if (res && res?.docs?.success) {
        setList({
          loading: false,
          data: res.docs?.data,
          pageCount: res?.docs?.metadata?.totalPages,
          keyword: search,
          totalItem: res?.docs?.metadata?.totalDocs,
        });
        setCount(res?.docs?.metadata?.totalDocs);
        setPagination({
          hasNextPage: res?.docs?.metadata?.hasNextPage,
          hasPrevPage: res?.docs?.metadata?.hasPrevPage,
        });
      } else {
        setList((pre) => ({ ...pre, data: [], loading: false }));
        toast.error(res?.message);
      }
    });
  }, [
    limit,
    sort,
    currentPage,
    search,
    filters,
    orderStatus?._id,
    user?._id,
    paymentStatus?._id,
    payment?._id,
    category?._id,
    maxDate,
  ]);

  useEffect(() => {
    loadList();
  }, [loadList]);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const pageParam = params.get("page");
    if (pageParam) {
      setCurrentPage(parseInt(pageParam, 10));
    }
  }, [location.search]);

  // Pagination Logic
  // useEffect(() => {
  //   if (list?.data?.length <= 0 && pagination?.hasNextPage) {
  //     setCurrentPage(currentPage);
  //   } else if (list?.data?.length <= 0 && !pagination?.hasPrevPage) {
  //     setCurrentPage(1);
  //   } else if (list?.data?.length <= 0) {
  //     setCurrentPage(currentPage - 1);
  //   }
  // }, [list?.data.length]);

  //Refresh Function

  const refreshData = () => {
    setLimit(10);
    setKeyword("");
    setSelectedItems([]);
    setOrderStatus({});
    setUser({});
    setPaymentStatus({});
    setPayment({});
    setCategory({});
    setMaxDate({ startDate: null, endDate: null });
  };

  const handleDownload = () => {
    const csvData = [[...tableHeadData.slice(0, -1).map((header) => header.name)]];

    tableData.forEach((item) => {
      const rowData = item.rowData.map((cell) => {
        if (
          cell.data &&
          cell.data.$$typeof === Symbol.for("react.element") &&
          cell.data.props &&
          cell.data.props.children
        ) {
          return cell.data.props.children;
        }

        if (cell.type === "status") {
          return cell.statusLabel;
        }

        return cell.data;
      });

      csvData.push(rowData);
    });

    const csvString = Papa.unparse(csvData);

    const blob = new Blob([csvString], { type: "text/csv" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "Order_list.csv";
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  //Table Heading Data >>>>>>>>>

  const tableHeadData = [
    {
      _id: 1,
      name: "Order Id",
      align: "left",
      isSort: true,
      isFilter: false,
      isFilterSearch: false,
      onSort: (val) => {
        if (val === "DESC") {
          setSort({ orderBy: "order_id", ordering: "DESC" });
        } else {
          setSort({ orderBy: "order_id", ordering: "ASC" });
        }
      },
    },
    {
      _id: 2,
      name: "Name",
      align: "left",
      isSort: true,
      isFilter: false,
      isFilterSearch: false,
      filterData: userFilterData,
      onFilter: (data) =>
        handleFilterChange(
          "userId",
          data?.map((item) => item?.value)
        ),
      filterSearch: (e) => setUserSearchKey(e),
      onSort: (val) => {
        if (val === "DESC") {
          setSort({ orderBy: "name", ordering: "DESC" });
        } else {
          setSort({ orderBy: "name", ordering: "ASC" });
        }
      },
    },
    {
      _id: 3,
      name: "Phone",
      align: "left",
      isFilter: false,
      isSort: false,
    },
    {
      _id: 4,
      name: "Order Status",
      align: "left",
      isFilter: true,
      isFilterSearch: false,
      isSort: false,
      filterData: statusFilterData,
      onFilter: (data) =>
        handleFilterChange(
          "status",
          data?.map((item) => item?.value)
        ),
      filterSearch: (e) => setFilterSearchKey(e),
      // onFilter: (data) => {
      //   setStatus(data?.map((item) => item?.value));
      //   setCurrentPage(1);
      //   setSelectedItems([]);
      // },
    },
    {
      _id: 5,
      name: "GST/HST(%)",
      align: "left",
      isFilter: false,
      isSort: false,
    },
    {
      _id: 6,
      name: "Price",
      align: "left",
      isFilter: false,
      isSort: false,
    },
    {
      _id: 7,
      name: "Order Date",
      align: "left",
      isFilter: false,
      isSort: false,
    },
    {
      _id: 8,
      name: "Payment Method",
      align: "left",
      isFilter: false,
      isSort: false,
    },
    {
      _id: 9,
      name: "Payment Status",
      align: "left",
      isFilter: false,
      isSort: false,
    },
    {
      _id: 10,
      name: "User Name",
      align: "left",
      isFilter: false,
      isSort: false,
    },
    {
      _id: 11,
      name: "Action",
      align: "right",
      isFilter: false,
      isSort: false,
    },
  ];
  // Multi selected Rows statuschange
  //   const handleActiveStatusToggle = () => {
  //     changeUserStatus({ ids: selectedItems, status: "active" })
  //       .then((res) => {
  //         if (res.data.status === 200) {
  //           setList((prevState) => ({
  //             ...prevState,
  //             data: prevState.data.map((user) =>
  //               selectedItems.includes(user._id) ? { ...user, status: "active" } : user
  //             ),
  //           }));
  //           setSelectedItems([]);
  //           toast.success(res?.data?.message);
  //         } else {
  //           toast.error(res?.data?.message);
  //         }
  //       })
  //       .catch();
  //   };

  //   const handleInactiveStatusToggle = () => {
  //     changeUserStatus({ ids: selectedItems, status: "inActive" })
  //       .then((res) => {
  //         if (res.data.status === 200) {
  //           setList((prevState) => ({
  //             ...prevState,
  //             data: prevState.data.map((user) =>
  //               selectedItems.includes(user._id) ? { ...user, status: "inActive" } : user
  //             ),
  //           }));
  //           setSelectedItems([]);
  //           toast.success(res?.data?.message);
  //         } else {
  //           toast.error(res?.data?.message);
  //         }
  //       })
  //       .catch();
  //   };

  const reportData = () => {
    navigate("/admin/order/report-list");
  };
  const editData = (item) => {
    navigate(`/admin/order-edit/${item}`);
  };
  const viewData = (item) => {
    navigate(`/admin/order-details/${item?.order_id}${location.search}`);
  };

  // Table Body Data >>>>>>>>>
  const tableData = list?.data?.map((item, index) => ({
    _id: item?.id,
    rowData: [
      {
        _id: 1,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px] !cursor-pointer",
        data: <Link to={`/admin/order-details/${item?.order_id}`}>{item?.order_id || ""}</Link>,
      },
      {
        _id: 2,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px]",
        data: JSON.parse(item?.user_info)?.name || "",
      },
      {
        _id: 3,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px]",
        data: JSON.parse(item?.user_info)?.contact_no || "",
      },
      {
        _id: 4,
        type: "status",
        align: "left",
        cellClass: "!min-w-[100px]",
        statusLabel: `${item?.orderStatusInfo?.name || ""} ${item?.orderStatusInfo?.processing_parcentage || ""}`,
        statusType:
          item?.status === 1
            ? "warning"
            : item?.status === 2
            ? "success"
            : item?.status === 3
            ? "secondary"
            : item?.status === 4
            ? "info"
            : item?.status === 5
            ? "danger"
            : "",
        // functions: () => {
        //   setIsOpen(true);
        //   setStatusDetails(item);
        // },
      },
      {
        _id: 5,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px]",
        data: item?.vat_charge.toFixed(2) || "N/A",
      },
      {
        _id: 6,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px] ",
        data: `${item?.total_price.toFixed(2) + " " + country}` || "N/A",
      },
      {
        _id: 7,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px] ",
        data: dayjs(item?.created_at).format("MMM DD,YYYY") || "N/A",
      },
      {
        _id: 8,
        type: "text",
        align: "center",
        cellClass: "!min-w-[100px] ",
        data: item?.payment || "N/A",
      },
      {
        _id: 9,
        type: "text",
        align: "center",
        cellClass: "!min-w-[100px] ",
        data:
          item?.payment_status === 1 ? (
            <span className="inline-block px-2 py-1 font-bold text-green-600 bg-green-100  rounded-md capitalize">
              Paid
            </span>
          ) : (
            (
              <span className="inline-block px-2 py-1 font-bold text-amber-600 bg-amber-100  rounded-md capitalize">
                Pending
              </span>
            ) || "N/A"
          ),
      },
      {
        _id: 10,
        type: "text",
        align: "left",
        cellClass: "!min-w-[100px]",
        data: item?.userData?.name || "",
      },
      {
        _id: 11,
        type: "action",
        align: "left",
        cellClass: "w-[5%]",
        actionData: [
          {
            _id: 1,
            name: "Update Status",
            icon: "fa-regular fa-refresh",
            standout: false,
            onClick: () => {
              setIsOpen(true);
              setStatusDetails(item);
            },
          },
          {
            _id: 2,
            name: "View Details",
            icon: "fa-regular fa-eye",
            standout: false,
            onClick: () => viewData(item),
          },
          // {
          //   _id: 3,
          //   name: "Delete",
          //   icon: "fa-regular fa-trash-can",
          //   standout: true,
          //   onClick: () => {
          //     setDeleteModal({
          //       isOpen: true,
          //       id: item?.id,
          //     });
          //   },
          // },
        ],
      },
    ],
  }));

  // data delte api call
  const onDelete = (item) => {
    setDeleteComplete(true);
    // if (deleteModal?.id) {
    //   try {
    //     deleteOrder({ id: deleteModal?.id }).then((res) => {
    //       if (res?.status === 200) {
    //         toast?.success(res?.message);
    //         setList((prevList) => ({
    //           ...prevList,
    //           data: prevList.data.filter((item) => item.id !== deleteModal.id),
    //         }));
    //         setDeleteModal({
    //           isOpen: false,
    //           id: null,
    //         });
    //       } else {
    //         toast.error(res?.message || res?.error);
    //       }
    //     });
    //     setDeleteComplete(false);
    //   } catch (error) {
    //     setDeleteComplete(false);
    //     // toast.error(error);
    //   }
    // }
  };

  return (
    <>
      <div className="w-full py-4 md:px-6 px-0">
        <div className="flex md:flex-row flex-col items-center justify-between font-bold text-3xl text-secondary mb-5 border-b border-gray-300 pb-2">
          <div>Orders</div>
          <div className="flex flex-col text-lg text-black">
            <div>Total Amount: {totalPriceSum.toFixed(2)}</div>
            <div className="mt-1">Total GST/HST: {totalGSTSum.toFixed(2)}</div>
          </div>
        </div>

        <div className="mb-3 md:flex block gap-2 md:space-y-0 space-y-2">
          <div className="flex flex-grow flex-shrink flex-wrap gap-2">
            <div className="2xl:w-44 md:w-32 w-full">
              <Select
                dropdownData={data}
                placeholder={"Select Limit"}
                dropdownButtonClass={"!h-10 !rounded-md "}
                selectedValue={limit}
                onChange={handleChange}
              />
            </div>
            <div className="2xl:w-80 md:w-56 w-full">
              <Input
                inputType={"text"}
                isInputGroup={true}
                inputGroupPosition={"left"}
                inputGroupIcon={"fa-regular fa-search"}
                inputPlaceholder={"Search"}
                inputClasses={"!pl-3"}
                value={keyword}
                onChange={(e) => {
                  setKeyword(e.target.value);
                  setCurrentPage(1);
                  setSelectedItems([]);
                }}
              />
            </div>

            <div className="2xl:w-60 md:w-56 w-full">
              <DatePickerInput
                asSingle={false}
                useRange={true}
                value={maxDate}
                onChange={(val) => {
                  setMaxDate(val);
                  setCurrentPage(1);
                  setSelectedItems([]);
                }}
              />
            </div>
            <div className="md:w-[11rem] w-full">
              <SelectDropdownSearch
                dropdownData={statusData}
                placeholder={"Select Order Status"}
                dropdownButtonClass={"!h-10 !rounded-md "}
                buttonArrowIconClasses={"!text-slate-500"}
                onChange={(e) => {
                  setOrderStatus({
                    name: e.target.value.name,
                    _id: e.target.value._id,
                  });
                  setCurrentPage(1);
                  setSelectedItems([]);
                }}
                isSearch={false}
                onSearch={(key) => setStatusKeyword(key)}
                value={orderStatus}
              />
            </div>
            <div className="md:w-[13rem] w-full">
              <SelectDropdownSearch
                dropdownData={
                  userList &&
                  userList?.data?.map((item) => ({
                    name: item?.name,
                    _id: item?.id,
                  }))
                }
                placeholder={"Select User Name"}
                dropdownButtonClass={"!h-10 !rounded-md "}
                buttonArrowIconClasses={"!text-slate-500"}
                onChange={(e) => {
                  setUser({
                    name: e.target.value.name,
                    _id: e.target.value._id,
                  });
                  setCurrentPage(1);
                  setSelectedItems([]);
                }}
                isSearch={true}
                onSearch={(key) => setUserKeyword(key)}
                value={user}
              />
            </div>
            <div className="2xl:w-60 md:w-48 w-full">
              <SelectDropdownSearch
                dropdownData={paymentStatusData}
                placeholder={"Select Payment Status"}
                dropdownButtonClass={"!h-10 !rounded-md "}
                buttonArrowIconClasses={"!text-slate-500"}
                onChange={(e) => {
                  setPaymentStatus({
                    name: e.target.value.name,
                    _id: e.target.value._id,
                  });
                  setCurrentPage(1);
                  setSelectedItems([]);
                }}
                isSearch={false}
                onSearch={(key) => setPaymentStatusKeyword(key)}
                value={paymentStatus}
              />
            </div>
            <div className="2xl:w-60 md:w-48 w-full">
              <SelectDropdownSearch
                dropdownData={paymentData}
                placeholder={"Select Payment Method"}
                dropdownButtonClass={"!h-10 !rounded-md "}
                buttonArrowIconClasses={"!text-slate-500"}
                onChange={(e) => {
                  setPayment({
                    name: e.target.value.name,
                    _id: e.target.value._id,
                  });
                  setCurrentPage(1);
                  setSelectedItems([]);
                }}
                isSearch={false}
                onSearch={(key) => setPaymentKeyword(key)}
                value={payment}
              />
            </div>
            <div className="2xl:w-60 md:w-48 w-full">
              <SelectDropdownSearch
                dropdownData={categoryData}
                placeholder={"Select Category"}
                dropdownButtonClass={"!h-10 !rounded-md "}
                buttonArrowIconClasses={"!text-slate-500"}
                onChange={(e) => {
                  setCategory({
                    name: e.target.value.name,
                    _id: e.target.value._id,
                  });
                  setCurrentPage(1);
                  setSelectedItems([]);
                }}
                isSearch={false}
                onSearch={(key) => setCategoryKeyword(key)}
                value={category}
              />
            </div>
          </div>
          {/* {selectedItems.length > 0 && (
            <>
              <div className="relative">
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-badge-check"}
                  buttonIconPosition={"left"}
                  buttonClasses={"!bg-org-green !border-org-border !text-white"}
                  buttonLabel={"Active"}
                  buttonLabelClasses={"font-medium !text-sm"}
                  buttonFunction={handleActiveStatusToggle}
                />
              </div>
            </>
          )}
          {selectedItems.length > 0 && (
            <>
              <div className="relative">
                <Button
                  buttonHasLink={false}
                  buttonIcon={"fa-regular fa-circle-xmark"}
                  buttonIconPosition={"left"}
                  buttonClasses={"!bg-org-red !border-org-border !text-white"}
                  buttonLabel={"In Active"}
                  buttonLabelClasses={"font-medium !text-sm"}
                  buttonFunction={handleInactiveStatusToggle}
                />
              </div>
            </>
          )} */}

          <div className="ml-auto flex justify-end space-x-2 flex-shrink-0">
            <div className="relative group">
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-solid fa-arrows-rotate"}
                buttonIconPosition={"left"}
                buttonClasses={
                  "!bg-secondary !h-10 !text-white !text-bold hover:!bg-secondary !border-org-theme  hover:!text-white"
                }
                buttonLabel={""}
                buttonLabelClasses={"font-medium !text-md xl:block hidden"}
                buttonFunction={refreshData}
              />
              <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 hidden group-hover:block px-3 py-2 text-sm text-white bg-gray-800 rounded shadow-lg">
                Reset
              </div>
            </div>
            <div className="relative group">
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-file"}
                buttonIconPosition={"left"}
                buttonClasses={
                  "!bg-secondary !h-10 !text-white !text-bold hover:!bg-secondary !border-org-theme  hover:!text-white"
                }
                buttonLabel={""}
                buttonLabelClasses={"font-medium !text-sm xl:block hidden"}
                buttonFunction={reportData}
              />
              <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 hidden group-hover:block px-3 py-2 text-sm text-white bg-gray-800 rounded shadow-lg">
                Report
              </div>
            </div>
            <div className="relative group">
              <Button
                buttonHasLink={false}
                buttonIcon={"fa-regular fa-download"}
                buttonIconPosition={"left"}
                buttonClasses={
                  "!bg-secondary !h-10 !text-white !text-bold hover:!bg-secondary !border-org-theme  hover:!text-white"
                }
                buttonLabel={""}
                buttonLabelClasses={"font-medium !text-sm xl:block hidden"}
                buttonFunction={handleDownload}
              />
              <div className="absolute left-1/2 transform -translate-x-1/2 bottom-full mb-2 hidden group-hover:block px-3 py-2 text-sm text-white bg-gray-800 rounded shadow-lg">
                CSV
              </div>
            </div>
          </div>
        </div>
        <div className="">
          <Table
            tableHeadData={tableHeadData}
            tableData={tableData}
            // containerClasses={"px-8"}
            isLoder={list?.loading}
            pageCount={list?.pageCount}
            currentPage={currentPage}
            onPageChange={(val) => {
              setOffset(limit * val?.selected);
              setCurrentPage(val?.selected);
              setSelectedItems([]);
              navigate(`?page=${val?.selected}`);
            }}
            isOrderingDisabled={true}
            originalData={[...list.data]}
            // handleOrdering={handleOrdering}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
            isCheckbox={false}
            setOriginalData={(data) => setList((cur) => ({ ...cur, data }))}
            tableImage={false}
          />
        </div>
      </div>
      <DeleteModal
        open={deleteModal?.isOpen}
        close={() => setDeleteModal({ isOpen: false })}
        loading={deleteComplete}
        deleteHandler={onDelete}
      />
      <Modal open={isOpen} title={`Order Maintainence for Order: ${statusDetails?.order_id}`} size="xl2">
        <OrderStatusChange
          onClose={() => setIsOpen(false)}
          statusDetails={statusDetails}
          setStatusDetails={setStatusDetails}
          list={list}
          setList={setList}
          loadList={loadList}
        />
      </Modal>
    </>
  );
};

export default OrderList;
